import { Injectable, WritableSignal, signal } from '@angular/core';

/**
 * Shared state of the site header. The home hero video sets `overVideo` while the header sits over
 * the video, and the shell hands it to the header: transparent over the video, solid after it.
 * A page without a hero never touches it, so the header stays solid there.
 */
@Injectable({ providedIn: 'root' })
export class SiteHeaderStateService {
    public readonly overVideo: WritableSignal<boolean> = signal<boolean>(false);
    /**
     * The header lies over the page instead of taking its own row: the hero starts at the window top,
     * under the header. Set by the hero on creation, the server render included, so the first paint
     * already has the video under the header and nothing shifts after the app starts
     */
    public readonly overlay: WritableSignal<boolean> = signal<boolean>(false);
}
